@if (rehearsal) {

  @if (rehearsal.purpose) {
    <p><span style="font-weight: bold;">Repetitie voor: </span> {{ rehearsal.purpose }}</p>
  }

  @if (rehearsal.notes) {
    <p><span style="font-weight: bold;">Algemene Opmerkingen: </span>{{ rehearsal.notes }}</p>
  }

  @for (scene of rehearsal.scenes; track scene.id) {
    @if (scene.required) {
      <p style="font-weight: bold;">{{ scene.name }}</p>

      @if (scene.notes) {
        <span style="">{{ scene.notes }}</span>
      }

      @if (scene.items.length > 0) {
        <ul>
          @for (item of scene.items; track item.id) {
            @if (item.required) {
              <li>
                {{ item.name }}
              </li>
            }

          }
        </ul>
      }

    }
  }

} @else {
  <p>Geen repetitie gevonden. </p>
}